// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-kpi-root {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  border-radius: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/analytics/analyticsKPI.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".analytics-kpi-root {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px;\n  border-radius: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
